import { DateInput } from '@palmetto/palmetto-components';
import { DateTime } from 'luxon';
import { useState } from 'react';

import { DataFilterOperation } from 'types';

import { FilterChange } from './FilterButton';

export const DateInputFilter = ({
  onFilterChange,
  appliedFilterId,
  defStartDate,
  defEndDate,
}: {
  onFilterChange: (change: FilterChange) => void;
  appliedFilterId: string;
  defStartDate?: Date;
  defEndDate?: Date;
}) => {
  const defaultStartDate = defStartDate ? defStartDate : DateTime.now().minus({ days: 2 }).toJSDate();
  const defaultEndDate = defEndDate ? defEndDate : DateTime.now().plus({ day: 2 }).endOf('day').toUTC().toJSDate();
  const [startDate, setStartDate] = useState<Date | null>(defaultStartDate || null);
  const [endDate, setEndDate] = useState<Date | null>(defaultEndDate || null);

  const handleClear = () => {
    setStartDate(null);
    setEndDate(null);
  };

  const setDate = ([startDate, endDate]: [Date | null, Date | null]) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  return (
    <DateInput
      datePickerProps={{
        onChange: (date) => {
          setDate(date as [Date | null, Date | null]);
          if ((date as Date[])[0] && (date as Date[])[1]) {
            onFilterChange({
              filterId: appliedFilterId,
              selectedValues: (date as Date[]).map((element, index) => {
                // Extract date components and create UTC date to avoid timezone shift
                const utcDate = DateTime.utc(
                  element.getFullYear(),
                  element.getMonth() + 1, // Luxon months are 1-indexed
                  element.getDate(),
                );
                if (index === 1) {
                  // Set end date to end of day in UTC
                  return utcDate.endOf('day').toISO()!;
                }
                // Set start date to start of day in UTC
                return utcDate.startOf('day').toISO()!;
              }),
              operation: DataFilterOperation.InRange,
            });
          }
        },
        selected: startDate,
        selectsRange: true,
        startDate: startDate,
        endDate: endDate,
      }}
      textInputProps={{
        onClear: handleClear,
        id: 'rangePickerDateForFilter',
        name: 'rangePickerDateForFilter',
        label: 'Select Date Range',
      }}
    />
  );
};
